<template>

<v-main class="mt-md-12 mt-8 mb-4">
    <v-card
        width=600
        flat
        dark
        class="mx-auto blueMain">
        <div class="text-center my-2 blueGrey--text">
            <v-icon class="blueGrey--text">store</v-icon>
            Магазины
        </div>

<!-- Shops card -->
        <v-card
            dark
            class="blueDark my-2">
            <div class="text-center"
                 v-if="totalInfo.factToday">
                за день<span class="ml-1 orangeMain--text">{{ totalInfo.factToday | moneyT }}</span> ({{totalInfo.planToday ? (totalInfo.factToday / totalInfo.planToday * 100).toFixed() : 0}}%) 
                из<span class="ml-1 orangeMain--text">{{ totalInfo.planToday | moneyT }}</span> ₽
            </div>
            <v-expansion-panels
                accordion
                dark
                flat
                focusable>
                <v-expansion-panel
                    v-for="shopid in totalInfo.shoplist"
                    :key="shopid"
                    class="blueDark" dense>
                    <v-expansion-panel-header>
                        <div class="">
                            {{shopinfo[shopid].ID}}
                        </div>
                        <div class="orangeMain--text">
                            {{shopinfo[shopid].shopname}}
                        </div>
                    </v-expansion-panel-header>

                    <v-lazy
                        :options="{ threshold: .5 }"
                        transition="fade-transition">

                        <Shop :shopid="shopid"/>

                    </v-lazy>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-card>
</v-main>

</template>

<script>

import Shop from './shop'
import {mapState, mapMutations} from 'vuex';


export default {
name: 'ShopList',
components: {
    Shop
},
data: () => ({
}),

computed: {
  ...mapState(['totalInfo', 'shopinfo']),

},

methods: {

  ...mapMutations([]),

},

created: function() {
}

}
</script>
<style scoped>
</style>
